import createLucideIcon from '../createLucideIcon';

const Umbrella = createLucideIcon('Umbrella', [
  ['path', { d: 'M22 12a10.06 10.06 1 0 0-20 0Z', key: '1teyop' }],
  ['path', { d: 'M12 12v8a2 2 0 0 0 4 0', key: 'ulpmoc' }],
  ['path', { d: 'M12 2v1', key: '11qlp1' }],
]);

export default Umbrella;
